export const GET_SHIPMENT_STATISTICS = 'GET_SHIPMENT_STATISTICS';
export const GET_SHIPMENT_STATISTICS_USER = 'GET_SHIPMENT_STATISTICS_USER';
export const DELETE_SHIPMENT_STATISTICS = 'DELETE_SHIPMENT_STATISTICS';
export const ADD_SHIPMENT_STATISTICS = 'ADD_SHIPMENT_STATISTICS';
export const CHANGE_LOADING = 'CHANGE_LOADING';
